import type useFollowUnfollow from 'src/hooks/useFollowUnfollow';
import type { icons } from 'src/components/ui/Icon';
import type { MenuOption } from 'src/types/MenuOption';

export const getFollowUnfollowMenuOptions = (
    { isFollowing, handleFollowClick, handleUnFollowClick, loading }: ReturnType<typeof useFollowUnfollow>,
    showCondition: boolean,
): Record<string, MenuOption> => {
    if (isFollowing === undefined) {
        return {};
    }
    const menuItemProps = { disabled: loading };
    return {
        follow: {
            mainTranslationKey: 'profile:follow',
            condition: showCondition && !isFollowing,
            handleClick: handleFollowClick as (ev: React.MouseEvent) => Promise<void>,
            iconName: 'PlusThin' as keyof typeof icons,
            menuItemProps,
        },
        unfollow: {
            mainTranslationKey: 'profile:unfollow',
            condition: showCondition && isFollowing,
            handleClick: handleUnFollowClick as (ev: React.MouseEvent) => Promise<void>,
            iconName: 'Minus' as keyof typeof icons,
            menuItemProps,
        },
    };
};
